import React from "react";
import seeWhatMattersIcon from "../assets/seeWhatMatters.svg";
import focusEnergyIcon from "../assets/focusEnergy.svg";
import turnIntentIcon from "../assets/turnIntent.svg";
import buildDisciplineIcon from "../assets/buildDiscipline.svg";
import alignTeamIcon from "../assets/alignTeam.svg";

const FeatureCard = ({ icon, title, description, comingSoon }) => {
  const match = description.match(/^(.*?[-—])([\s\S]*)$/);
  const before = match ? match[1] : null;
  const after = match ? match[2] : description;

  return (
    <div className="feature-card">
      <div className="feature-heading">
        <div className="feature-icon">{icon}</div>
        <h3 className="feature-title">
          {title}
          {comingSoon && <span className="coming-soon"> (Coming Soon)</span>}
        </h3>
      </div>
      <p className="feature-description">
        {before && <span className="desc-highlight">{before}</span>}
        {after}
      </p>
    </div>
  );
};

const Features = () => {
  return (
    <section className="features">
      <div className="features-header">
        <p className="features-label">Crafted for strategic leaders</p>
        <h2 className="features-title">
          Stop managing tasks. Start shaping outcomes
        </h2>
      </div>
      <div className="features-grid">
        <div className="feature-highlight-card">
          <p className="feature-highlight-text">
            vectr42 helps strategic leaders separate signal from noise, focus their energy, and turn daily execution into measurable momentum.
          </p>
        </div>
        <div className="features-rows">
          <div className="features-row-wide">
            <FeatureCard
              icon={<img src={seeWhatMattersIcon} alt="" />}
              title="See what matters"
              description="Understand which work is strategic, operational, controllable, influence-based, or simply noise — so attention goes where impact is created."
            />
            <FeatureCard
              icon={<img src={focusEnergyIcon} alt="" />}
              title="Focus your leadership energy"
              description="Protect time for the few decisions, conversations, and commitments that change outcomes instead of reacting to everything equally."
            />
          </div>
          <div className="features-row-three">
            <FeatureCard
              icon={<img src={turnIntentIcon} alt="" />}
              title="Turn intent into execution"
              description="Convert priorities into practical next moves: focus, delegate, challenge, rethink, or stop."
            />
            <FeatureCard
              icon={<img src={buildDisciplineIcon} alt="" />}
              title="Build strategic discipline"
              description="Develop stronger habits around prioritisation, delegation, alignment, and execution — without adding another layer of management overhead."
            />
            <FeatureCard
              icon={<img src={alignTeamIcon} alt="" />}
              title="Align the team"
              description="Create shared clarity on what matters, who owns it, and where effort should be concentrated."
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
